import { useMemo, useState } from 'react';
import './EmployeeCardList.css';

import LoadingSpinner from '../LoadingSpinner';
import EmployeeCard from './EmployeeCard';

const EmployeeCardList = ({
  isLoading,
  employees,
  onEmployeeClick,

  openAddEmployee,
  // Controlled search (optional)
  externalQuery,
  onQueryChange,
}) => {
  const [localQuery, setLocalQuery] = useState('');
  const query = externalQuery !== undefined ? externalQuery : localQuery;
  const setQuery = typeof onQueryChange === 'function' ? onQueryChange : setLocalQuery;

  const filteredEmployees = useMemo(() => {
    const q = (query || '').trim().toLowerCase();
    if (!q) return employees;

    return employees.filter((e) => {
      const employeeCode = (e.employeeCode || '').toLowerCase();
      const name = (e.name || '').toLowerCase();
      const email = (e.email || '').toLowerCase();
      const phone = (e.phone || '').toLowerCase();

      const rego = e.vehicle?.vehicleCode?.toLowerCase() ?? '';

      return (
        employeeCode.includes(q) ||
        name.includes(q) ||
        email.includes(q) ||
        phone.includes(q) ||
        rego.includes(q)
      );
    });
  }, [employees, query]);

  return (
    <div className="ecl-root">
      {/* Search Header - Only shows if not controlled by parent */}
      {externalQuery === undefined && (
        <header className="ecl-header">
          <div className="ecl-search-wrapper">
            <i className="bi bi-search ecl-icon" />
            <input
              type="text"
              className="ecl-input"
              placeholder="Filter employees..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            {query && (
              <button
                type="button"
                className="ecl-clear"
                onClick={() => setQuery('')}
                aria-label="Clear search"
              >
                <i className="bi bi-x-circle-fill" />
              </button>
            )}
          </div>

          {openAddEmployee && (
            <button type="button" className="ecl-btn-add" onClick={openAddEmployee}>
              <i className="bi bi-person-plus-fill" />
            </button>
          )}
        </header>
      )}

      <main className="ecl-body">
        {isLoading ? (
          <div className="ecl-center">
            <LoadingSpinner />
          </div>
        ) : filteredEmployees.length === 0 ? (
          <div className="ecl-empty-state">
            <div className="ecl-empty-art">
              <i className="bi bi-people-fill" />
            </div>
            <h3>No Employees Found</h3>
            <p>Your search returned no results.</p>

            {openAddEmployee && (
              <button type="button" className="ecl-cta-empty" onClick={openAddEmployee}>
                Add Employee
              </button>
            )}
          </div>
        ) : (
          <div className="ecl-grid">
            {filteredEmployees.map((employee, idx) => (
              <div
                key={employee._id}
                className="ecl-card-anim"
                style={{ animationDelay: `${idx * 0.05}s` }}
              >
                <EmployeeCard
                  employee={employee}
                  handleEmployeeClick={() => onEmployeeClick(employee)}
                />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default EmployeeCardList;
